import script from "./names.vue?vue&type=script&setup=true&lang=js"
export * from "./names.vue?vue&type=script&setup=true&lang=js"

import "./names.vue?vue&type=style&index=0&id=6cd6e4ee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cd6e4ee"]])

export default __exports__